module.exports = __webpack_public_path__ + "static/fonts/DaimlerCS-Demi.bf41f45e.ttf";